export default "/images/emailBlack.svg?289363f7e5392483a1f18a35379868ba";